import { ContentState, convertToRaw, EditorState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

export const logDebug = (...log: any) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug(...log)
  }
}

export const createEditorState = (note: string) => {
  const contentBlock = htmlToDraft(note)

  if (contentBlock && note) {
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
      contentBlock.entityMap
    )
    return EditorState.createWithContent(contentState)
  } else {
    return EditorState.createEmpty()
  }
}

export const getHtml = (editorState: EditorState) => {
  const rawContentState = convertToRaw(editorState.getCurrentContent())

  return draftToHtml(rawContentState, {}, true)
}
